import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from "react";
import * as PropTypes from "prop-types";
import { SearchkitComponent, renderComponent } from "../../../../core";

var defaults = require("lodash/defaults");

var identity = require("lodash/identity");

var HitsStatsDisplay = function HitsStatsDisplay(props) {
  var resultsFoundLabel = props.resultsFoundLabel,
      bemBlocks = props.bemBlocks;
  return React.createElement("div", {
    className: bemBlocks.container(),
    "data-qa": "hits-stats"
  }, React.createElement("div", {
    className: bemBlocks.container("info"),
    "data-qa": "info"
  }, resultsFoundLabel));
};

export var HitsStats =
/*#__PURE__*/
function (_SearchkitComponent) {
  _inherits(HitsStats, _SearchkitComponent);

  function HitsStats() {
    var _this;

    _classCallCheck(this, HitsStats);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HitsStats).apply(this, arguments));
    _this.translations = HitsStats.translations;
    return _this;
  }

  _createClass(HitsStats, [{
    key: "defineBEMBlocks",
    value: function defineBEMBlocks() {
      return {
        container: this.props.mod || "sk-hits-stats"
      };
    }
  }, {
    key: "render",
    value: function render() {
      var timeTaken = this.searchkit.getTime();
      var countFormatter = this.props.countFormatter;
      var hitsCount = countFormatter(this.searchkit.getHitsCount());
      var props = {
        bemBlocks: this.bemBlocks,
        translate: this.translate,
        timeTaken: timeTaken,
        hitsCount: hitsCount,
        resultsFoundLabel: this.translate("hitstats.results_found", {
          timeTaken: timeTaken,
          hitCount: hitsCount
        })
      };
      return renderComponent(this.props.component, props);
    }
  }]);

  return HitsStats;
}(SearchkitComponent);
HitsStats.translations = {
  "hitstats.results_found": "{hitCount} results found in {timeTaken}ms"
};
HitsStats.propTypes = defaults({
  translations: SearchkitComponent.translationsPropType(HitsStats.translations),
  countFormatter: PropTypes.func
}, SearchkitComponent.propTypes);
HitsStats.defaultProps = {
  component: HitsStatsDisplay,
  countFormatter: identity
};